//to be used instead of imported localStorageService
import { localStorageService } from "@next-platform/client-common-core";

type LocalStorageWebType = Omit<typeof localStorageService, "getItem" | "setItem"> & {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
};

const typedLocalStorageService = localStorageService as unknown as LocalStorageWebType;

export { typedLocalStorageService };
